var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((Object.keys(_vm.sections).sort((a, b) => _vm.sections[a].order - _vm.sections[b].order)),function(key){return _c('SocialSection',_vm._b({},'SocialSection',_vm.sections[key],false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }